// Vuex records module actions
import { hParseToFilterCriteriaObjectRequiredByApi } from '@/utils/helpers';
import { API } from '@/config';

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
  FILL_LIST_EMPTY_CLIENTS,
  SET_RECORDS_PER_PAGE,
} from './mutations-types';

export default {
  async getList({ state, commit }) {
    try {
      const params = {
        filtering_criteria: hParseToFilterCriteriaObjectRequiredByApi(state.filteringCriteria),
        page: state.list.page,
        recordsPerPage: state.recordsPerPage,
      };
      const { records, total } = (await API.get('/records/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      if (err.message.includes('422')) {
        commit(FILL_LIST_EMPTY_CLIENTS, {});
      }
      console.log(err);
    }
  },

  filterList({ commit, dispatch }, params) {
    try {
      const filterCriteria = {};
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== '') {
          filterCriteria[key] = {
            value: params[key],
            name: key,
            label: key,
          };
        }
      });

      commit(SET_FILTERING_CRITERIA, { ...filterCriteria });
      commit(SET_PAGE, { page: 1 });
      dispatch('getList');
    } catch (err) {
      console.log(err);
    }
  },

  clearFilteringCriteria({ commit }) {
    commit(SET_FILTERING_CRITERIA, {});
    commit(SET_PAGE, { page: 1 });
  },

  changePage({ commit, dispatch }, params) {
    commit(SET_PAGE, { page: params.page });
    dispatch('getList');
  },

  changeRecordsPerPage({ commit, dispatch }, params) {
    commit(SET_RECORDS_PER_PAGE, { recordsPerPage: params.recordsPerPage });
    commit(SET_PAGE, { page: 1 });
    dispatch('getList');
  },
};
